import { Link, generatePath } from 'react-router-dom';
import moment from 'moment';
import ComparisonBarChart from 'components/common/comparison-bar-chart/ComparisonBarChart';
import ComparisonBarChartMobile from 'components/common/comparison-bar-chart/ComparisonBarChartMobile';
import { asTimestringFormated, displayNumberWithSign } from 'reports/cw/services/report.service';
import { DATE_FORMATS, VALUE_NA, VALUE_NA_TEXT } from 'reports/cw/constants/report.constant';
import { PerformancePath, ASSIGNMENT_GRADE_TYPES } from 'reports/cw/constants/cw.constant';
import { renderWeightedGradePoints } from 'reports/cw/helpers/report.helper';
export var renderName = function (row) {
    var path = generatePath(PerformancePath.studentEngagement.studentDetail, {
        studentId: row.studentId.toString()
    });
    return (<div className="c-cw-student-engagement-table__student-name-cell" title={row.studentName}>
      <Link to={path}>
        <span>{row.studentName}</span>
      </Link>
    </div>);
};
export var renderAvgTimePerQuestion = function (row) {
    var avgTimePerQuestionSeconds = row.avgTimePerQuestionSeconds;
    if (avgTimePerQuestionSeconds === 0) {
        return <span>{VALUE_NA}</span>;
    }
    return <span>{asTimestringFormated(avgTimePerQuestionSeconds)}</span>;
};
export var renderComparedPerformance = function (row, maxPerformanceComparedToClassAvg) {
    var avgScore = row.avgScore;
    var value = +(+avgScore.toFixed(2) - +maxPerformanceComparedToClassAvg.toFixed(2)).toFixed(2);
    var backgroundColorClassName = value > 0 ? 'u-els-background-color-extended-green-8' : 'u-els-background-color-warn';
    var maxValue = maxPerformanceComparedToClassAvg > 1 ? maxPerformanceComparedToClassAvg : 1;
    return (<ComparisonBarChart value={value} maxValue={maxValue} backgroundColorClassName={backgroundColorClassName} displayTextValue={displayNumberWithSign(value)} barChartThickness={1.5}/>);
};
export var renderComparedPerformanceMobile = function (row, maxPerformanceComparedToClassAvg) {
    var avgScore = row.avgScore;
    var value = +(avgScore - maxPerformanceComparedToClassAvg).toFixed(2);
    var maxValue = maxPerformanceComparedToClassAvg > 1 ? maxPerformanceComparedToClassAvg : 1;
    return <ComparisonBarChartMobile value={value} maxValue={maxValue} displayTextValue={displayNumberWithSign(value)}/>;
};
export var renderPastDue = function (row) {
    var colorClassName = +row.pastDue > 0 ? 'u-els-color-warn' : 'u-els-color-n6';
    return <span className={colorClassName}>{row.pastDue}</span>;
};
export var renderStudentAvgScore = function (row) {
    if (!row.avgScore) {
        return <span>{VALUE_NA_TEXT}</span>;
    }
    return <span>{"".concat(+(row.avgScore * 100).toFixed(0), "%")}</span>;
};
export var renderAvgTimePerQuestionComparedToClass = function (row) {
    var avgTimePerQuestionComparedToClassAvgSeconds = row.avgTimePerQuestionComparedToClassAvgSeconds;
    if (avgTimePerQuestionComparedToClassAvgSeconds === 0) {
        return <span>Same</span>;
    }
    var displayTime = asTimestringFormated(Math.abs(avgTimePerQuestionComparedToClassAvgSeconds));
    return <span>{avgTimePerQuestionComparedToClassAvgSeconds > 0 ? "+".concat(displayTime) : "-".concat(displayTime)}</span>;
};
export var renderTotalLogins = function (row) {
    var _a;
    return <span>{(_a = row === null || row === void 0 ? void 0 : row.totalLogins) !== null && _a !== void 0 ? _a : 0}</span>;
};
export var renderLastLogin = function (row) {
    if (!row.lastLogin) {
        return <span>{VALUE_NA}</span>;
    }
    var lastLogin = moment(row.lastLogin);
    return <span>{lastLogin.isValid() ? lastLogin.format(DATE_FORMATS.TIMESTAMP) : VALUE_NA}</span>;
};
export var renderTotalSelfStudyTime = function (row) {
    var totalTimeSpentOnSelfStudySeconds = row.totalTimeSpentOnSelfStudySeconds;
    if (!totalTimeSpentOnSelfStudySeconds) {
        return <span>{VALUE_NA}</span>;
    }
    return <span>{asTimestringFormated(totalTimeSpentOnSelfStudySeconds)}</span>;
};
export var renderStudentTotalGradePoints = function (row, featureFlags) {
    var avgScore = row.avgScore, totalGradePoints = row.totalGradePoints;
    return (<span>
      {renderWeightedGradePoints({
            assignmentGradeType: ASSIGNMENT_GRADE_TYPES.SCORED.key,
            points: avgScore,
            totalPoints: totalGradePoints,
            featureFlags: featureFlags,
            courseId: '',
            withParenthesis: false
        })}
    </span>);
};
